import * as React from 'react';
import { LinkText } from '@origin-digital/style-guide';
import { Box } from '@origin-digital/layout';
import { CenteredHeading } from '../../../../components/CentredHeading';
import { CancelIcon } from '@origin-digital/icon';
import { ErrorViewContent } from './ErrorViewContent';
import { IFramePage } from '../../../../login/components/iframe-login/IFramePage';
import { MarkdownLite, Text } from '@origin-digital/ods-core';

interface IFrameErrorViewProps {
  errorMessage: string;
  title: string;
  onContinueWithoutLogin: () => void;
}

const IFrameErrorView: React.FC<IFrameErrorViewProps> = ({
  title,
  errorMessage,
  onContinueWithoutLogin,
}) => (
  <IFramePage>
    <ErrorViewContent>
      <Box marginBottom={6}>
        <CancelIcon data-id="error-icon" color={'redPink'} size={40} />
      </Box>
      <Box marginBottom={4}>
        <CenteredHeading data-id="error-title" text={title} />
      </Box>
      <Box marginBottom={6}>
        <Text align="center" data-id="error-msg">
          <MarkdownLite>{errorMessage}</MarkdownLite>
        </Text>
      </Box>
      <Box alignContent="center">
        <LinkText
          color="red"
          data-id="continue-without-login"
          onClick={onContinueWithoutLogin}
          href="#"
          text="Continue without logging in"
        />
      </Box>
    </ErrorViewContent>
  </IFramePage>
);

export { IFrameErrorView };
